export default () => ({
  entities: 'rules',
  rules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/summary-agenda/resources/data.js